export enum NavigationSteps {
    Summary = "summary",
    Calculation = "calculation",
}
